import React, { useRef } from 'react';
import CreateTicketMessageInput from './CreateTicketMessageInput';
import ChatMessageFooter from '../../ChatComponents/ChatMessageFooter';
import { Avatar } from '@mui/material';
import { colorCodesForAvatar } from '../../../../constants/index';
import { chracterPosition } from '../../../../utils/index';
import './style.css';

function CreateTicketMessageContainer({
  setSelectedState,
  setActiveTicketMerge,
  onSubmit,
  description,
  setDescription,
  loading,
  onCancel,
}) {
  const messageContainerRef = useRef(null);

  const msgTime = (time) => {
    const date = new Date(time);
    const options = {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    };
    return date.toLocaleTimeString(undefined, options);
  };

  return (
    <div className="ChatMessageComponent-Container-Ticket">
      {/* <div className="MessageComponet-Main">
        <div className="MessageComponent-Main-02" ref={messageContainerRef}>
          <div className="Message-Time-Header">
            <span className="Left-Line" />
            <p className="Message-Time-Text">
              Ticket created: {msgTime(new Date())}
            </p>
            <span className="right-Line" />
          </div>
          
          {messages.map((message, index) => (
            <div
              key={index}
              className={`Message-Container ${
                message.isAgent ? 'agent-message' : 'user-message'
              }`}
            >
              {!message.isAgent && (
                <Avatar
                  sx={{
                    bgcolor: colorCodesForAvatar[
                      chracterPosition(message.sender?.substring(0, 1).toUpperCase())
                    ],
                  }}
                >
                  {message.sender?.substring(0, 1).toUpperCase()}
                </Avatar>
              )}
              
              <div className={message.isAgent ? 'Img-Content-Agent' : 'Img-Content'}>
                {message.content && (
                  <div className="message-text-container">
                    <div className="Message-Content">
                      <p className="Message-Text">{message.content}</p>
                    </div>
                  </div>
                )}
                {message.file_image && (
                  <div className="image-container">
                    <img 
                      src={message.file_image} 
                      alt="Attached" 
                      style={{ maxWidth: '200px', borderRadius: '8px' }}
                    />
                  </div>
                )}
              </div>
              
              <div className="User-message-text-down">
                <div className="message-status">
                  <p className="User-Messagetime01">{msgTime(message.timestamp)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div> */}
      
      {/* <div className="ChatMessage_Container_Input " style={{paddingLeft:'0px',paddingRight:'0px'}}> */}
        <CreateTicketMessageInput
          setSelectedState={setSelectedState}
          setActiveTicketMerge={setActiveTicketMerge}
          handleSubmit={onSubmit}
          description={description}
          setDescription={setDescription}
          loading={loading}
          onCancel={onCancel}
        />
      {/* </div> */}
      {/* <div className=" ticketmessage-footer">
        <ChatMessageFooter />
      </div> */}
    </div>
  );
}

export default CreateTicketMessageContainer;
